import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../components/PageLoader";
import { selectDBNDomainAccountMappingsListItems } from "../../../../../../redux/dbn-cloud/dbn-domain-account-mappings/selector";
import { dbnDomainAccountMappings } from "../../../../../../redux/dbn-cloud/dbn-domain-account-mappings/action";
interface AccountMappingProps {
  accountId?: number
  id?: number,
  filters?: any
}


const DBNDomainAccountMappings = ({ accountId, id, filters }: AccountMappingProps) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [searchCriteriaList, setSerchCriteriaList] = useState<any>([]);
  const dbnDomainAccountMappingsListData = useSelector(selectDBNDomainAccountMappingsListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'AccountName', headerName: 'Account Name', searchField: 'AccountName', sortable: true, filter: true, filterType: 'text' },
      { field: 'EdgeDBNDomainName', headerName: 'Edge DBN Domain Name', searchField: 'EdgeDBNDomainName', sortable: true, filter: true, filterType: 'text' },
      { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Populate Account Mappings</title>
          <path d="M6.93745 10C6.24652 10.0051 5.83076 10.0263 5.4996 10.114C3.99238 10.5131 2.96048 11.8639 3.00111 13.3847C3.01288 13.8252 3.18057 14.3696 3.51595 15.4585C4.32309 18.079 5.67958 20.3539 8.7184 20.8997C9.27699 21 9.90556 21 11.1627 21L12.8372 21C14.0943 21 14.7229 21 15.2815 20.8997C18.3203 20.3539 19.6768 18.079 20.4839 15.4585C20.8193 14.3696 20.987 13.8252 20.9988 13.3847C21.0394 11.8639 20.0075 10.5131 18.5003 10.114C18.1691 10.0263 17.7534 10.0051 17.0625 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M12 3L12 14M12 3C12.4683 3 12.8243 3.4381 13.5364 4.3143L14.5 5.5M12 3C11.5316 3 11.1756 3.4381 10.4635 4.3143L9.49995 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handlePopulateDBNDomainAccountMappings(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Publish Account Mappings</title>
          <path d="M17.4776 9.01106C17.485 9.01102 17.4925 9.01101 17.5 9.01101C19.9853 9.01101 22 11.0294 22 13.5193C22 15.8398 20.25 17.7508 18 18M17.4776 9.01106C17.4924 8.84606 17.5 8.67896 17.5 8.51009C17.5 5.46695 15.0376 3 12 3C9.12324 3 6.76233 5.21267 6.52042 8.03192M17.4776 9.01106C17.3753 10.1476 16.9286 11.1846 16.2428 12.0165M6.52042 8.03192C3.98398 8.27373 2 10.4139 2 13.0183C2 15.4417 3.71776 17.4632 6 17.9273M6.52042 8.03192C6.67826 8.01687 6.83823 8.00917 7 8.00917C8.12582 8.00917 9.16474 8.38194 10.0005 9.01101" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 13L12 21M12 13C11.2998 13 9.99153 14.9943 9.5 15.5M12 13C12.7002 13 14.0085 14.9943 14.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handlePublishDBNDomainAccountMappings(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const fetchDBNDomainAccountMappingsList = () => {
    dispatch(dbnDomainAccountMappings.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domain-account-mappings/fetch`,
      entity: 'dbnDomainAccountMappings',
      jsonData:
      {
        Context: {},
        Records: [
          {
            EdgeDBNDomainId: id ? id : undefined,
            AccountId: accountId ? accountId : undefined
          }
        ],
        Pagination: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "CreatedOnUtc",
          SortOrder: "desc",
          Searches: searchCriteriaList || undefined,
          Filters: filters || undefined
        }
      }
    }))
  }

  const handlePopulateDBNDomainAccountMappings = async () => {
    await dispatch(dbnDomainAccountMappings.resetAction({ actionType: 'update' }))
    await dispatch(dbnDomainAccountMappings.update({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domain-account-mappings`,
      entity: 'dbnDomainAccountMappings',
      jsonData:
      {
        Context: {},
        Records: [{}]
      }
    })).then(() => {
      fetchDBNDomainAccountMappingsList();
    });
  }

  const handlePublishDBNDomainAccountMappings = async () => {
    await dispatch(dbnDomainAccountMappings.resetAction({ actionType: 'publish' }))
    await dispatch(dbnDomainAccountMappings.publish({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domain-account-mappings/publish`,
      entity: 'dbnDomainAccountMappings',
      jsonData:
      {
        Context: {},
        Records: [{}]
      }
    })).then(() => {
      fetchDBNDomainAccountMappingsList();
    });
  }

  const handleReloadData = () => {
    fetchDBNDomainAccountMappingsList();
  }

  const handleSearch = (data: any) => {
    let searchCriteria = [];
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "EdgeDBNDomainName",
        FieldText: "EdgeDBNDomainName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    setSerchCriteriaList(searchCriteria)
    fetchDBNDomainAccountMappingsList();
  }

  useEffect(() => {
    createColumnDefs();
    fetchDBNDomainAccountMappingsList();
  }, [pageData, pageSize, searchCriteriaList])

  return (
    <>
      {dbnDomainAccountMappingsListData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={dbnDomainAccountMappingsListData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          searchCriteriaList={searchCriteriaList}
          paginationData={dbnDomainAccountMappingsListData?.result?.pagination}
          enableFilter={true} onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'EdgeDBNDomainId',
          }}
          additionButtons={additionButtons}
          headingName="Domain Account Mappings"
        />
      }
    </>
  );
};

export default DBNDomainAccountMappings;


